import { render, staticRenderFns } from "./FiscalDocuments.vue?vue&type=template&id=5f456f04&scoped=true&"
import script from "./FiscalDocuments.vue?vue&type=script&lang=js&"
export * from "./FiscalDocuments.vue?vue&type=script&lang=js&"
import style0 from "./FiscalDocuments.vue?vue&type=style&index=0&id=5f456f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f456f04",
  null
  
)

export default component.exports